module.exports = __webpack_public_path__ + "img/lens-174-plus-03.b95dc6fa.png";